// DATAS DOS RELATÓRIOS NO IDIOMA DA PESSOA (07/10/2026). Os gráficos diziam
// "01-Oct", "Oct-2026"; o mapa de calor, "Oct 1, 2026".
import { getAppLocale } from 'dashboard/components/ui/DatePicker/helpers/DatePickerHelper';

const formato = (opcoes, locale) =>
  new Intl.DateTimeFormat((locale || getAppLocale()).replace('_', '-'), opcoes);

// "1 de out."
export const diaCurto = (data, locale) =>
  formato({ day: 'numeric', month: 'short' }, locale).format(data);

// "out. de 2026"
export const mesDoAno = (data, locale) =>
  formato({ month: 'short', year: 'numeric' }, locale).format(data);

// "1 – 7 de out." (semana do gráfico agrupado por semana)
export const semanaCurta = (inicio, fim, locale) =>
  formato({ day: 'numeric', month: 'short' }, locale).formatRange(inicio, fim);
